import React, { useEffect, useState, useContext } from 'react'
import UserTableView from '@/custom/components/organisms/User/TableView'
import { Button } from '@mui/material'
import Layout from '../../product/components/templates/Layout'
import DynamicUser from './AddUser'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()
    const { user_tablefields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        user_type: 0,
    })
    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null

    const toggleFullScreenPopup = (popup, status, id) => {
        if (status === 'edit') {
            handleRedirectInternal(history, `user/edit/${id}`)
        } else {
            if (popup) {
                setManage({ popup, status, id })
            } else {
                setManage({ popup, status: 'new', id: 0 })
            }
        }
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `user/edit/${id}`)
        }
    }

    const custom = {
        action: {
            value: action,
            type: 'in',
            field: 'u.status',
        },
    }

    const similar = {
        admin: {
            value: '0',
            type: 'in',
            field: 'u.admin',
        },
        both: {
            value: '1',
            type: 'in',
            field: 'cu.both_access',
        },
    }

    useEffect(() => {
        if (user_tablefields && user_tablefields.length) {
            console.log(user_tablefields, 'tableuser')
            let dynamicValueAssign = {}
            let tableFields = [
                ...user_tablefields,
                {
                    view_page: '3',
                    filter_type: 'in',
                    field: 'created_at',
                    is_default: 1,
                    type: 'datetime',

                    label: 'Created At',
                    name: 'created_at',
                },
            ]
            let searchData = [...user_tablefields]
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            tableFields.map((data) => {
                if (data.field === 'email') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })
            dynamicValueAssign.data.push({
                view_page: '3',
                filter_type: 'in',
                field: 'is_requested',
                is_default: 1,
                type: 'switch',
                // type: 'text',
                label: 'Requested user',
                name: 'is_requested',
                filter: true,
            })
            setSearchInfo(dynamicValueAssign)
            setTableValue(tableFields)
        }
    }, [user_tablefields, action])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                        <Button
                            id="userManage_dynamic_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0)
                            }
                        >
                            <span className="material-icons">
                                person_add_alt_1
                            </span>
                            Add Individual User
                        </Button>
                        <Button
                            id="userManage_dynamic_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_user_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>

                    <UserTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        customSimilar={similar}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={
                            global?.user_tableActionString
                                ? global.user_tableActionString
                                : []
                        }
                        action={action}
                        advFilters={
                            global?.advFilters ? global.advFilters : false
                        }
                        columnStorageVariable={'table_user'}
                        requestUserAccess={true}
                        listActionString={['cancelrequest', 'switchuser']}
                    />
                </div>
                <DynamicUser data={manage} function={toggleFullScreenPopup} />
            </Layout>
        </>
    )
}

export default UserCommon
